import moment from "moment";
import "moment-timezone";

export function formatDate(date: Date | string | null | undefined, empty= ""): string {
    if (date instanceof String)
        date = new Date(date);
    
    if (!date)
        return empty;

    return moment(date).tz("Europe/Tallinn").format("DD.MM.YYYY");
}

export function formatTime(date: Date | string | null | undefined, empty= ""): string {
    if (date instanceof String)
        date = new Date(date);
    
    if (!date)
        return empty;
    
    return moment(date).tz("Europe/Tallinn").format("HH:mm (z)");
}

// So that JSON.stringify keeps offset. By default it will convert it to UTC.
Date.prototype.toISOString = function () {
    return moment(this).format();
}